import { Maybe } from '@csp/csp-common-model';

type GenericVersion = {
  version?: string;
  [k: string]: unknown;
};

type GenericRequest = {
  requestCode?: string;
  allowedVersions?: GenericVersion[];
  [k: string]: unknown;
};

export const matchRequestCode = <T extends GenericRequest>(requestCode?: string, request?: T): boolean =>
  !!requestCode && !!request?.requestCode && requestCode.trim() === request.requestCode.trim();

export const matchVersion = <T extends GenericRequest>(version?: string, request?: T): Maybe<GenericVersion> => {
  const trimmedVersion = version?.trim();

  if (trimmedVersion) {
    return request?.allowedVersions?.find(
      allowedVersion => !!allowedVersion.version && allowedVersion.version.trim() === trimmedVersion,
    );
  } else {
    return undefined;
  }
};

// This is used for the migrated scheduling content in contentstack.
// Please remove the code above when Medication scheduling and Device scheduling is migrated.
type GenericVersionV2 = {
  version?: string;
};

type GenericRequestV2 = {
  request_code?: string;
};

export const matchRequestCodeV2 = <T extends GenericRequestV2>(requestCode?: string, request?: T): boolean =>
  !!requestCode && !!request?.request_code && requestCode.trim() === request.request_code?.trim();

export const matchVersionV2 = <T extends GenericVersionV2>(version?: string, request?: T): boolean => {
  const trimmedVersion = version?.trim();

  if (trimmedVersion) {
    return !!request?.version && request.version.trim() === trimmedVersion;
  } else {
    return false;
  }
};
